import { useState } from "react";
import "./IndexMaster.css";
import IndexHostDepartment from "./HostDepartment/IndexHostDepartment";
import Tab from "../../../Components/Molecules/Tabs";
import {
  MASTER_SETTINGS,
  MODULES,
  ROLE_BY_PERMISSIONS,
} from "../../../Constant";
import IndexPurposeOfVisit from "./PurposeOfVisit/IndexPurposeOfVisit";
import IndexConfigCode from "./ConfigCode/IndexConfigCode";
import IndexDestination from "./Destination/IndexDestination";
import IndexType from "./Type/IndexType";
import IndexClient from "./Client/IndexClient";
import { hasPermission } from "../../../Utils/getters";
import { useSelector } from "react-redux";
const IndexMaster = () => {
  const { getUserResponse } = useSelector((state) => state.user);
  const tabs = [
    { label: "Host Department", value: MASTER_SETTINGS.HOST_DEPARTMENT },
    { label: "Purpose Of Visit", value: MASTER_SETTINGS.PURPOSE_OF_VISIT },
    { label: "Client", value: MASTER_SETTINGS.CLIENT },
    { label: "Destination", value: MASTER_SETTINGS.DESTINATION },
    { label: "Type", value: MASTER_SETTINGS.TYPE },
  ];

  const [currentTab, setCurrentTab] = useState("HOST_DEPARTMENT");

  const permissions = {
    CREATE: hasPermission(
      [ROLE_BY_PERMISSIONS[MODULES.MASTER_SETTINGS].CREATE_MASTER_SETTINGS],
      getUserResponse?.data
    ),
    UPDATE: hasPermission(
      [ROLE_BY_PERMISSIONS[MODULES.MASTER_SETTINGS].UPDATE_MASTER_SETTINGS],
      getUserResponse?.data
    ),
    STATUS: hasPermission(
      [ROLE_BY_PERMISSIONS[MODULES.MASTER_SETTINGS].STATUS_MASTER_SETTINGS],
      getUserResponse?.data
    ),
  };

  const renderCurrTab = () => {
    switch (currentTab) {
      case MASTER_SETTINGS.HOST_DEPARTMENT:
        return <IndexHostDepartment permissions={permissions} />;
      case MASTER_SETTINGS.PURPOSE_OF_VISIT:
        return <IndexPurposeOfVisit permissions={permissions} />;
      case MASTER_SETTINGS.CONFIG_CODE:
        return <IndexConfigCode permissions={permissions} />;
      case MASTER_SETTINGS.CLIENT:
        return <IndexClient permissions={permissions} />;
      case MASTER_SETTINGS.DESTINATION:
        return <IndexDestination permissions={permissions} />;
      case MASTER_SETTINGS.TYPE:
        return <IndexType permissions={permissions} />;
      default:
        return null;
    }
  };

  return (
    <>
      <div>
        <div className="mb-15">
          <Tab
            tabs={tabs}
            selectedTab={currentTab}
            handleTabChange={(tab) => setCurrentTab(tab)}
          />
        </div>
        <section>{renderCurrTab()}</section>
      </div>
    </>
  );
};
export default IndexMaster;
